import { axiosGet, axiosPost, PostHeaders } from "base/lib/api";
import { encrypt } from "./encrypt";
import {
  LoginResponseType,
  SessionStatusResponseType,
} from "types/auth/login";

type LoginParams = {
  userName: string;
  password: string;
};

export const login = ({ userName, password }: LoginParams) => {
  const params = {
    gw_id: encrypt(userName),
    gw_pass: encrypt(password),
  };

  return axiosPost<LoginResponseType>(
    "/sign/auth",
    params,
    PostHeaders,
    undefined,
    {
      isGroupwareUrl: true,
    }
  );
};

// HANBIRO_GW is httpOnly now, so JS can no longer read it to tell if the session is valid.
// The server checks it for us, since the cookie still rides along via withCredentials.
export const checkSessionStatus = () => {
  return axiosPost<SessionStatusResponseType>(
    "/sign/session_status",
    undefined,
    PostHeaders,
    undefined,
    {
      isGroupwareUrl: true,
    }
  );
};

// An httpOnly cookie can't be cleared from JS, so logout has to go through the server.
export const signOut = () => {
  return axiosGet("/sign/out", undefined, undefined, undefined, {
    isGroupwareUrl: true,
  });
};
